<template>
  <div v-if="loading" class="loading-container">
    <van-loading size="24px" vertical>出额中...</van-loading>
  </div>
  <div v-else class="countdown-container">
      <!-- 打雷图标 -->
    <div v-if="countdown > 0" class="countdown-animation">
    <img src="../assets/money.png" class="lightning-icon" alt="Lightning"/>
    <br>
    <div class="circle-animation"></div>
    {{ countdown }}s
  </div>
    <div v-else>
      <!-- 倒计时结束后的内容，可以是重定向或者显示额度信息 -->
      <!-- 举例显示额度信息 -->
      <div class="result-container">
        <div class="amount-circle">￥{{amount}}</div>
        <div class="congratulations">恭喜您，获得额度</div>
        <div class="rate">贷款年利率: <span style="color:red">{{rate}}%</span></div>
        <br>
        <br>
        <br>
        <van-button type="danger" block round class="loan-button" @click="rent">去借款</van-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from "vue-router";
import {useRoute} from 'vue-router';
import { defineProps } from 'vue';

// 定义接收的props
const props = defineProps({
  bankCardNumber: String,
  userid: String,
  email: String,
});

const route = useRoute(); // 使用 useRoute 获取当前路由对象;


// 访问查询参数
const router = useRouter();
const loading = ref(true);
const countdown = ref(3);
const amount = ref(route.query.amount);
const rate = ref(route.query.rate);

//获取额度和rate的值。


setTimeout(() => {
  loading.value = false;
  const intervalId = setInterval(() => {
    countdown.value--;
    if (countdown.value === 0) {
      clearInterval(intervalId);
    }
  }, 1000);

}, 2000); // 假设加载需要1秒

const rent = ()=>{
    router.push({
      path: '/loanApplication',
      query: {
        rate: rate.value,
        amount: amount.value,
        account: props.bankCardNumber,
        userid: props.userid,
        email: props.email,
      }
    })
}
</script>


<style scoped>
.loading-container,
.countdown-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(145deg, #f0f5ff 0%, #fff 100%);
}

.result-container {
  text-align: center;
  padding: 24px;
}

.amount-circle {
  width: 130px;
  height: 130px;
  line-height: 110px;
  border-radius: 60px;
  background: linear-gradient(135deg, #1677ff, #69b1ff);
  color: white;
  margin: 20px auto;
  font-size: 19px;
  font-weight: bold;
  box-shadow: 0 8px 20px rgba(22, 119, 255, 0.3);
}

.congratulations {
  font-size: 20px;
  font-weight: 600;
  color: #1677ff;
  margin-top: 16px;
}

.rate {
  font-size: 14px;
  color: #666;
  margin-top: 8px;
}

.loan-button {
  margin-top: 32px;
  width: calc(100% - 48px);
  margin-left: auto;
  margin-right: auto;
  border-radius: 30px !important;
  font-weight: 600;
  background: linear-gradient(135deg, #1677ff, #4096ff) !important;
  border: none;
  box-shadow: 0 4px 12px rgba(22, 119, 255, 0.3);
}

/* 倒计时动画 */
.countdown-animation {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 56px;
  font-weight: bold;
  color: #1677ff;
}

.lightning-icon {
  width: 100px;
  height: 100px;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,0.1));
  animation: bounce 1s infinite alternate;
}

.circle-animation {
  position: absolute;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  border: 4px solid rgba(22, 119, 255, 0.2);
  border-top-color: #1677ff;
  animation: spin 1s linear infinite;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

@keyframes spin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}

@keyframes bounce {
  from { transform: translateY(0); }
  to { transform: translateY(-10px); }
}
</style>


<!-- <style scoped>
.loading-container,
.countdown-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* 全屏高度 */
}

.result-container {
  text-align: center;
}

.amount-circle {
  width: 120px;
  height: 120px;
  line-height: 120px;
  border-radius: 50%;
  background-color: red;
  color: white;
  margin: 20px auto;
  font-size: 24px;
}

.congratulations, .rate {
  margin-top: 10px;
}

.lightning-icon {
  width: 100px; /* 调整图标的宽度 */
  height: 100px; /* 调整图标的高度 */
}

.rate{
  font-size: 12px;
  color: gray;
}

.loan-button {
  margin-top: 20px;
}
/* 现有样式保持不变，添加以下新样式 */

.countdown-animation {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 48px; /* 调整倒计时数字的大小 */
}

.circle-animation {
  position: absolute;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  border: 25px solid rgba(243, 214, 221, 0.5);
  border-bottom-color: rgb(236, 77, 77); /* 半圈的颜色 */
  box-shadow: 0 0 20px rgb(226, 172, 172); /* 光晕效果 */
  animation: spin 1s linear infinite;
}

.loading-text {
  /* position: absolute; */
  top: -250px; /* 根据需要调整，以确保文字显示在圆圈上方 */
  font-size: 20px; /* 调整文字大小 */
  color: hsl(0, 91%, 44%); /* 文字颜色，可以根据您的设计进行调整 */
  font-weight: bold; /* 加粗字体 */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style> -->
